module.exports = __webpack_public_path__ + "media/images/usr-logo-7e13e4f8d6782780cf0fd6b8779c3c7b.png";